module.exports = __webpack_public_path__ + "files/520620e28daa1e89e07ee8e049d939d5.png";